import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import React, { FC } from 'react';
import styled from 'styled-components';
import {
  TextFieldContainer,
  TextFieldErrorBanner,
  TextFieldInputContainer,
} from './TextField.styles';
import { Width } from '../../types';
import { Banner } from '../Banner';

type TextFieldProps = {
  error?: Maybe<string>;
  width?: Width;
  startIconName?: TrevorIconName;
  endIconName?: TrevorIconName;
  value?: string;
  onChange: F<string>;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>;

export const TextField: FC<TextFieldProps> = ({
  error,
  width,
  startIconName,
  endIconName,
  onChange,
  className,
  ...props
}) => {
  return (
    <TextFieldContainer width={width} className={className}>
      <TextFieldInputContainer>
        {startIconName && <TrevorIcon name={startIconName} />}
        <input onChange={(e) => onChange(e.target.value)} {...props} />
        {endIconName && <TrevorIcon name={endIconName} />}
      </TextFieldInputContainer>
      {error && <TextFieldErrorBanner>{error}</TextFieldErrorBanner>}
    </TextFieldContainer>
  );
};
